export const COMMON_CAMPAIGN_SETTINGS_DATA_REQUEST = 'COMMON_CAMPAIGN_SETTINGS_DATA_REQUEST';
export const COMMON_CAMPAIGN_SETTINGS_DATA_SUCCESS = 'COMMON_CAMPAIGN_SETTINGS_DATA_SUCCESS';
export const COMMON_CAMPAIGN_SETTINGS_DATA_FAIL = 'COMMON_CAMPAIGN_SETTINGS_DATA_FAIL';

export const COMMON_CAMPAIGN_SETTINGS_CLEAR_DATA = 'COMMON_CAMPAIGN_SETTINGS_CLEAR_DATA';
export const COMMON_CAMPAIGN_SETTINGS_SET_ALLOW_EDIT_TEMPLATE = 'COMMON_CAMPAIGN_SETTINGS_SET_ALLOW_EDIT_TEMPLATE';
